import React from 'react';
import { DataMappingProps } from 'enums/CreateProductStageNavigationBarEnums';
import { ReactComponent as Truck } from 'assets/icons/transportation.svg';
import { ReactComponent as RawMaterial } from 'assets/icons/raw_material.svg';
import { ReactComponent as FuelAndEnergy } from 'assets/icons/processing_factor.svg';
import { ReactComponent as CommodityDistribution } from 'assets/icons/distribution.svg';
import { ReactComponent as Field } from 'assets/icons/field.svg';
import { isActiveTab } from '../DataMapDrawer/DataMapDrawerHelper';
import { Location } from 'react-router-dom';
const {
  RAW_MATERIAL_HEADING,
  TRANSPORTATION_HEADING,
  FUEL_AND_ENERGY,
  FUEL_AND_ENERGY_HEADING,
  TRANSPORTATION,
  RAW_MATERIAL,
  COMMODITY_DISTRIBUTION,
  COMMODITY_DISTRIBUTION_HEADING,
  FIELD,
  FIELD_HEADING,
} = DataMappingProps;

export const footerItems = (location: Location) => [
  {
    key: 1,
    icon: <RawMaterial />,
    title: RAW_MATERIAL_HEADING,
    isActive: isActiveTab(RAW_MATERIAL, location, true),
  },
  {
    key: 2,
    icon: <Truck />,
    title: TRANSPORTATION_HEADING,
    isActive: isActiveTab(TRANSPORTATION, location, true),
  },
  {
    key: 3,
    icon: <FuelAndEnergy />,
    title: FUEL_AND_ENERGY_HEADING,
    isActive: isActiveTab(FUEL_AND_ENERGY, location, true),
  },
  {
    key: 4,
    icon: <Field />,
    title: FIELD_HEADING,
    isActive: isActiveTab(FIELD, location, true),
  },
  {
    key: 5,
    icon: <CommodityDistribution />,
    title: COMMODITY_DISTRIBUTION_HEADING,
    isActive: isActiveTab(COMMODITY_DISTRIBUTION, location, true),
  },
];
